import keyMirror from 'keymirror';

const LocaleConstants = keyMirror({
  SWITCH_LANGUAGE: null,
});

export default LocaleConstants;
